/**
* @name: page-card-space
* @author: weiyong
* @date: 2023-03-31 20:45
* @description：page-card-space
* @update: 2023-03-31 20:45
*/
<template>
  <div :class="prefixCls" class="themeAttr-item">
    <span class="themeAttr-item-title">{{t('左侧菜单宽度')}}</span>
    <div class="themeAttr-item-body w100b">
      <a-slider id="test" v-model:value="leftMenuWidth" :max="450" :min="150" :marks="marks"/>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "left-menu-space",
});
</script>

<script lang="ts" setup>
import {Slider as aSlider} from "ant-design-vue";
import {useDesign} from "@/hooks/web/useDesign";
import {baseHandler} from "@/layouts/default/setting/handler";
import {HandlerEnum} from "@/layouts/default/setting/enum";
import {useI18n} from "vue-i18n";
import {useRootSetting} from "@/hooks/setting/useRootSetting";
const {t} = useI18n();
const { getLeftMenuWidth } = useRootSetting();

const leftMenuWidth=ref(unref(getLeftMenuWidth));
const marks = ref<Record<number, any>>({
  180: '180',
  220: '220',
  280: '280',
  320: '320',
  380: '380',
  450: '450',
});

//设置卡片空间
watch(leftMenuWidth,(newVal)=>{
  baseHandler(HandlerEnum.MENU_WIDTH_LEFT, unref(newVal))
  baseHandler(HandlerEnum.MENU_WIDTH, unref(newVal))
})

const {prefixCls} = useDesign('page-card-space');
</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-page-card-space';

.@{prefix-cls} {
  width: 100%;
  padding: 16px;
  margin-bottom: 10px;
  border-radius: 6px;
  background: #fff;
  font-family: PingFangSC-Semibold,PingFang SC;
  .themeAttr-item-body{
    flex-wrap: wrap;
  }
  .themeAttr-item-title {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #111;
    margin-bottom: 14px;
  }
  .itme-title-span{
    text-align: center;
    margin-top: 6px;
  }
  .item-type-sign {
    width: 56px;
    height: 56px;
    padding: 3px;
    border: 1px solid #fff;
    border-radius: 3px;
    margin-right: 12px;
  }
}
</style>
